import { createContext } from 'react';
/*
 * Provides default element for the portal property
 */
export const DefaultPortalContext = createContext(null);
//# sourceMappingURL=DefaultPortalContext.js.map